import axios from "axios";

const state = {
  userInfo: {
    placeholderData: true,
    firstName: "Sports Fan",
    lastName: "",
    year: "XXXX",
    repName: "Rep Name",
    repEmail: "ref@team.com",
    repPhone: "(000)-000-0000",
  },
  loadedItems: {
    images: false,
    video: false,
    userInfo: false,
    fonts: false,
  },
  allUserAccs: [],
  isMobile: false,
};

const getters = {
  getUserInfo: (state) => state.userInfo,
};

const actions = {
  async fetchUserInfo({ commit }) {
    const purl = location.pathname.split("/").pop();
    const response = await axios.post(
      process.env.VUE_APP_BASE_URL + "/api/router/Users.php",
      {
        action: "getUserByPurl",
        prefix: "rays2021",
        purl: purl,
        timestamp: new Date(),
      }
    );
    console.log("response", response);
    commit("setUserInfo", response ? response.data : "fetchUserInfoFailed");
    commit("setLoadedItem", {
      loadedProperty: "userInfo",
      isLoaded: true,
    });
  },
  async setLoadedItem({ commit }, payload) {
    commit("setLoadedItem", payload);
  },
  async setUserInfoObject({ commit }, payload) {
    commit("setUserInfoObject", payload);
  },
  async setIsMobile({ commit }, payload) {
    commit("setIsMobile", payload);
  },
};

const mutations = {
  setUserInfo: (state, payload) => {
    if (!payload.output || payload.output.length < 1) {
      //state.userInfo.status = 'not found';
      state.userInfo = {
        accountId: "999999999",
        address1: "One Tropicana Drive",
        address2: "",
        balance2: "$0.00",
        balance4: "$0.00",
        balance8: "$0.00",
        balance12: "$0.00",
        balance20: "$0.00",
        balance500: "$0.00",
        city: "St. Petersburg",
        email: "",
        financialFormatName: "Rays Fan",
        firstName: "Rays",
        hits: "0",
        id: "9999",
        lastName: "Fan",
        lasttime: "999999999",
        middleName: "",
        ownerName: "Rays Fan",
        purl: "generic",
        repEmail: "seasonticketservices@raysbaseball.com",
        repName: "Your Rays Representative Ticket Sales",
        repPhone: "727-825-3250",
        sgtBonus: "$0.00",
        sgtCredit: "0",
        stBonus: "$0.00",
        stCredit: "$0.00",
        state: "FL",
        totalBonus: "$0.00",
        totalCredit: " $ -   ",
        zip: "33705"
      };
      return;
    }
    let userInfo = payload.output[0];
    state.userInfo = userInfo;
    state.allUserAccs = payload.output;
  },
  setUserInfoObject: (state, payload) => {
    if (!payload) return;
    state.userInfo = payload;
  },
  setLoadedItem: (state, payload) => {
    state.loadedItems = {
      ...state.loadedItems,
      [payload.loadedProperty]: payload.isLoaded,
    };
  },
  setIsMobile: (state, payload) => {
    state.isMobile = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
